import entityMetaStore from "data/meta/entityMetaStore";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import {
    FT_CHILD,
    FT_GLOBAL_REFERENCE_ONLY,
} from "data/meta/MappingInfoStore";

export const buildChildDef = (edgeKey, sourceKey, type) => ({
    edge: {
        fieldKey: edgeKey,
        sourceFieldKey: edgeKey
    },
    sourceKey: sourceKey,
    targetKey: sourceKey,
    type: type
});

export const buildCrossTreeDef = (fieldKey, ownerPath) => ({
    fieldKey: fieldKey,
    sourceFieldKey: fieldKey,
    sourceOwnerPath: ownerPath,
    targetOwnerPath: ownerPath
});


export const getAllParentsEntityInfo = (info, parents = []) => {
    if(!info.parentPointerKey) {
        return [];
    }
    const pInfo = entityFieldMetaStore.getInfo(info.key, info.parentPointerKey);
    parents.push(pInfo);
    if(pInfo.parentPointerKey === "parent") {
        // recursive
        return getAllParentsEntityInfo(pInfo, parents);
    }
    return parents;
};

export const buildCrossTreeInfo = (sourceEntityInfo, targetEntityInfo) => {
    const sourceParentsInfo = getAllParentsEntityInfo(sourceEntityInfo);
    const targetParentsInfo = getAllParentsEntityInfo(targetEntityInfo);
    // find common ancestors and use inverse key as path
    const path = [];
    let rootKey = sourceEntityInfo.key;
    breakAll:
        for(const spIndex in sourceParentsInfo) {
            const spi = sourceParentsInfo[spIndex];
            for(const tpIndex in targetParentsInfo) {
                const tpi = targetParentsInfo[tpIndex];
                if(spi.otherEntityKey === tpi.otherEntityKey) {
                    rootKey = tpi.otherEntityKey;
                    path.push(spi.inverseKey);
                    break breakAll; // break out of both, all done.
                }
            }
        }
    return {
        rootKey: rootKey, // key where crossTree def belongs
        path // parent path from root to field
    };
};

export const buildSelfToSelfMappingDef = (KeyOrEntityInfo) => {
    const entityInfo = typeof KeyOrEntityInfo === "string" ? entityMetaStore.getInfo(KeyOrEntityInfo) : KeyOrEntityInfo;
    const entityFieldInfos = entityFieldMetaStore.getAllInfos(entityInfo.key);
    const children = [];
    const fields = [];
    const crossTree = [];
    let ei = {};
    entityFieldInfos.forEach((fi) => {
        if(fi.mrPointer) return; // ignore magic root pointer fields
        if(fi.calculated && !fi.nonUpdateable) return; // ignore updateable calculated fields
        if (fi.offForm) return; // ignore off-form fields
        switch(fi.type) {
            case "FileField": // file fields should not be mapped.
            case "InverseAssociationField": // will be taken care of for free.
                break;
            case "AssociationField":
                ei = entityMetaStore.getInfo(fi.otherEntityKey);
                if(ei.type === "GLOBAL") {
                    children.push(
                        buildChildDef(
                            fi.key,
                            fi.otherEntityKey,
                            FT_GLOBAL_REFERENCE_ONLY
                        ));
                }
                else {
                    // if ei.type is not global then it is a cross tree.
                    // this is just indicator that we have a cross tree
                    // the cross tree belongs to a different mapping definition.
                    const cti = buildCrossTreeInfo(entityInfo, ei);
                    crossTree.push({
                        key: cti.rootKey,
                        def: buildCrossTreeDef(fi.key, cti.path)
                    });
                }
                break;
            case "CompositionField": // always children
                if(!!fi.autoManageKey) {
                    // TODO: we remove auto managed fields here because mapping
                    // exclusions currently does not support the ability to
                    // exclude all of its child fields. This gets us around that
                    // limitation.
                    return;
                }
                ei = entityMetaStore.getInfo(fi.otherEntityKey);
                children.push(
                    buildChildDef(
                        fi.key,
                        fi.otherEntityKey,
                        FT_CHILD
                    ));
                break;
            default:
                // everything else is a field
                fields.push({
                    fieldKey: fi.key,
                    sourceFieldKey: fi.key,
                });
        }
    });

    return {
        INFO: {
            children: children,
            crossTrees: [], // has to be reconciled outside this function.
            fields: fields,
            sourceKey: entityInfo.key, // should be the same
            targetKey: entityInfo.key,
            type: entityInfo.type
        },
        crossTreeRoots: crossTree, // used to reconcile crossTrees
    };
};


export const getSelfToSelfMappingDefs = () => {
    const mappingDefs = [];
    const crossTreeDefs = {};
    entityMetaStore.getAllInfos().forEach((info) => {
        const def = buildSelfToSelfMappingDef(info);
        if (def.crossTreeRoots.length) {
            // store cross tree definitions in lookup table keyed by who it belong to.
            def.crossTreeRoots.forEach((ct) => {
                if (!crossTreeDefs[ct.key]) {
                    crossTreeDefs[ct.key] = [];
                }
                crossTreeDefs[ct.key].push(ct.def);
            });
        }
        delete def.crossTreeRoots; // removed
        mappingDefs.push(def);
    });
    mappingDefs.forEach((def) => {
        if (crossTreeDefs.hasOwnProperty(def.INFO.sourceKey)) {
            // add cross tree to def.INFO.crossTrees
            def.INFO.crossTrees = crossTreeDefs[def.INFO.sourceKey];
        }
    });
    return mappingDefs;
};



// WEBPACK FOOTER //
// ./app/data/util/merge/buildSelfToSelfMappingDef.js